import {
  PROFESSIONAL_DETAILS_FETCHED_SUCCESS,
  PROFESSIONAL_DETAILS_FETCHED_FAILURE,
} from './types';
import { logger } from '../logger';

const log = logger();

const professionalDetailsFetchedAction =
  (status) => async (dispatch) => {
    try {
      dispatch({
        type: PROFESSIONAL_DETAILS_FETCHED_SUCCESS,
        payload: status,
      });
    } catch (err) {
      log.error(
        'Error dispatching professional details fetched action',
        err,
      );
      dispatch({
        type: PROFESSIONAL_DETAILS_FETCHED_FAILURE,
        payload: status,
      });
    }
  };

export default professionalDetailsFetchedAction;
